
		<svg width="60" height="60" version="1.1" viewBox="0 0 15.875 15.875" xmlns="http://www.w3.org/2000/svg">
			<g>
				<path d="m1.5334 12.639h5.2602m7.3855-10.423c1.4523 0.28362 1.5231
				1.8258 1.5231 1.8258m-2.3378-0.90404c1.4523 0.28362 1.4523 1.6308
				1.4523 1.6308m-4.0042 5.0703a0.22539 0.22487 0 0 0 0.22539 0.22487
				0.22539 0.22487 0 0 0 0.22539-0.22487 0.22539 0.22487 0 0 0-0.22539-0.22487
				0.22539 0.22487 0 0 0-0.22539 0.22487zm-2.0353-4.8724v5.8646a0.23854
				0.23798 0 0 0 0.23854 0.23798h4.1313a0.23854 0.23798 0 0 0 0.23854-0.23798v-5.8646a0.23854
				0.23798 0 0 0-0.23854-0.23798h-4.1313a0.23854 0.23798 0 0 0-0.23854
				0.23798zm-7.7409 6.8839h6.3553m-6.3553-4.0291v3.7911a1.081 1.0785 0 0
				1-0.10038 0.45387l-0.56774 1.221a0.1523 0.15194 0 0 0 0.13816
				0.21588h7.4245a0.15153 0.15118 0 0 0 0.13716-0.21542l-0.57501-1.2219a1.0694
				1.0669 0 0 1-0.10137-0.45341v-3.7911a0.23854 0.23798 0 0 0-0.23854-0.23798h-5.8783a0.23854
				0.23798 0 0 0-0.23854 0.23798z" fill="none" stroke="#0C3121" stroke-linecap="round" stroke-linejoin="round" stroke-width=".52917"/>
			</g>
		</svg>
	